var path = '/card/component/tpl/app-html.html';
var html = "<div dynamic-bind-html={{$ctrl.item.app.html}}></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/card/component/tpl/app-html.html
// module id = 379
// module chunks = 1 2 3 4